import { createContext } from "react";

import React, { useEffect, useState } from 'react'
import { db } from './Firebase';
import { collection, deleteDoc, doc, onSnapshot, orderBy, query } from 'firebase/firestore';
export const AuthContext=createContext()

export const  AuthProvider=({children})=>{

const [furnitureData,setFurniture]=useState([])
useEffect(()=>{
const sparepartsCollectionRef = collection(db, "moraraFurnitures");
const sparepartsQuery = query(sparepartsCollectionRef, orderBy("createdAt", "desc"));
  const unsubParts = onSnapshot(sparepartsQuery, (partsSnapshot) => {
    setFurniture(partsSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  });

  return ()=>{
    unsubParts()
  }

  },[])



       
    return (
        <AuthContext.Provider value={furnitureData}>
        {children}
        </AuthContext.Provider>
    )
}